import axios from 'services/network/axios';

export const GetByCourseId = (id) => axios.get(`Lesson/GetByCourseId?courseId=${id}`);
export const GetDetails = (id) => axios.get(`Lesson/GetDetails?lessonId=${id}`);

export const GetContentTypes = (id) => axios.get(`Lesson/GetContentTypes`);

export const GetAdminByCourseId = (id) => axios.get(`Lesson/GetAdminByCourseId?courseId=${id}`);
export const GetAdminDetails = (id) => axios.get(`Lesson/GetAdminDetails?lessonId=${id}`);
export const GetAdminDetail = (id) => axios.get(`Lesson/GetAdminDetail?lessonDetailId=${id}`);
export const GetAdminLesson = (id) => axios.get(`Lesson/GetAdminLesson?lessonId=${id}`);

export const Create = (model) => axios.post('Lesson/Create', model);

export const CreateSub = (model) => axios.post('Lesson/CreateSub', model);

export const CreateDetail = (data) => axios.post('Lesson/CreateDetail', data, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    }
});
export const UpdateDetail = (data) => axios.post('Lesson/UpdateDetail', data, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    }
});

export const Update = (model) => axios.post('Lesson/Update', model);
export const UpdateLessonDescription = (model) => axios.post('Lesson/UpdateLessonDescription', model);

export const Delete = (id) => axios.post(`Lesson/Delete?id=${id}`);
export const DeleteDetail = (id) => axios.post(`Lesson/DeleteDetail?id=${id}`);

